import { createFileRoute } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { OnboardingActivities } from "@/features/settings/components/onboarding-activities"
import {
  FitAndProperSettings,
  OnboardingDeadlines,
} from "@/features/settings/components/onboarding-settings"
import { firmRecordQueries } from "@/queries/firm-record"
import { organisationQueries } from "@/queries/organisations"
import { permissionQueries } from "@/queries/permissions"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/settings/organisation/onboarding/"
)({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(organisationQueries.current()),
      context.queryClient.ensureQueryData(firmRecordQueries.permissions()),
      context.queryClient.ensureQueryData(permissionQueries.groups()),
    ]),
  component: OnboardingSettingsPage,
})

function OnboardingSettingsPage() {
  return (
    <>
      <PageHeader title="Onboarding" />
      <PageContent>
        <OnboardingActivities />
        <OnboardingDeadlines />
        <FitAndProperSettings />
      </PageContent>
    </>
  )
}
